import { render } from "./BasicLayout.vue?vue&type=template&id=2fbdcb5c&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=2fbdcb5c&lang=scss&scoped=true"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdcb5c"]])

export default __exports__